import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { oneOfType, number, string } from 'prop-types';
import Image from '../../atoms/ResponsiveImage';
import { Wrapper } from './badge.styles';

const Badges = props => {
  const {
    width,
    height,
    url,
    tooltip
  } = props;
  const newUrl = url && url.replace('{w}', width).replace('{h}', height);
  return url ? /*#__PURE__*/React.createElement(Wrapper, _extends({}, props, {
    "data-testid": "wrapper-badge"
  }), /*#__PURE__*/React.createElement(Image, _extends({
    src: newUrl,
    alt: tooltip,
    "data-testid": "badge"
  }, props))) : null;
};

process.env.NODE_ENV !== "production" ? Badges.propTypes = {
  url: string.isRequired,
  tooltip: string,
  width: oneOfType([string, number]),
  height: oneOfType([string, number])
} : void 0;
Badges.defaultProps = {
  tooltip: '',
  width: '65',
  height: '50'
};
export default Badges;